import { render, staticRenderFns } from "./AnexarMarcacaoDocumentos.vue?vue&type=template&id=70b992ca&"
import script from "./AnexarMarcacaoDocumentos.vue?vue&type=script&lang=js&"
export * from "./AnexarMarcacaoDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports